import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step11 } from '../../../../shared/models/component-messages/mapaIN/step11';
import { DocPrix } from '../models/DocPrix';
@Component({
  selector: 'app-doc-prix',
  templateUrl: './doc-prix.component.html'
})
export class DocPrixComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'DocPrix';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() docPrix: DocPrix;

  public step11 = new Step11();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

